import * as React from "react";

function SvgHamburger(props) {
  return <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="currentColor" fillRule="evenodd" d="M6 9h20v1H6V9zm0 6h20v1H6v-1zm20 6H6v1h20v-1z" clipRule="evenodd" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/hamburger_dfd0eb.svg";
export { SvgHamburger as ReactComponent };